// // import { getRequest, postRequest } from './apiRequests'; // Adjust the path to your API request helper
// import { getRequest } from './getRequest';
// import { postRequest } from './postRequest';
// // Function to handle GET request
// export function getWorkScreenDataAPI(callId , memberId) {
//   console.log("urli1", callId, memberId);
//   const baseUrl = process.env.REACT_APP_GET_WORK_SCREEN_DATA_API;
//   const url = `${baseUrl}&customerId=${memberId}&callId=${callId}`;
//   console.log("urli", url);
//   return getRequest(url);  // Perform GET request
// }

// // Function to handle POST request
// export function postWorkScreenDataAPI(payload) {
//   const { customerId } = payload;
//   const baseUrl = process.env.REACT_APP_GET_WORK_SCREEN_DATA_API;
//   const url = `${baseUrl}&customerId=${customerId}`;
//   return postRequest(url, payload);  // Perform POST request
// }
// import { getRequest, postRequest } from './apiRequests'; // Adjust the path to your API request helper
import { getRequest } from "./getRequest";
import { postRequest } from "./postRequest";

// Helper to get auth headers
const getAuthHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    Authorization: `Bearer ${authToken}`,
  };
};

// Function to handle GET request
export function getWorkScreenDataAPI(callId, memberId) {
  console.log("urli1", callId, memberId);

  const baseUrl = process.env.REACT_APP_GET_WORK_SCREEN_DATA_API;
  const url = `${baseUrl}&customerId=${memberId}&callId=${callId}`;

  console.log("urli", url);

  return getRequest(url, {
    headers: getAuthHeaders(),
  }); // Perform GET request
}

// Function to handle POST request
export function postWorkScreenDataAPI(payload) {
  const { customerId } = payload;


  console.log(payload,"service ")

  const baseUrl = process.env.REACT_APP_GET_WORK_SCREEN_DATA_API;
  const url = `${baseUrl}&customerId=${customerId}`;

  return postRequest(url, payload, {
    headers: getAuthHeaders(),
  }); // Perform POST request
}
